import deleteBtn from 'src/assets/userPage/dim/dim_delete_btn.png'
import googleBtn from 'src/assets/userPage/dim/dim_GooglePlay_btn.png'
import appStoreBtn from 'src/assets/userPage/dim/dim_AppStore_btn.png'
import mo_googleBtn from 'src/assets/userPage/dim/dim_mo_GooglePlay_btn.png'
import mo_appStoreBtn from 'src/assets/userPage/dim/dim_mo_AppStore_btn.png'
import useWindowDimensions from "src/hooks/useGetWindowSize";
import { BtnWrap, Button, DimBG, DimWrap } from "src/styles/views/UserPage/storePickerDim"
import {APP_STORE_WARD, IOS_APP_STORE_WARD} from "src/service/constant/url"

interface StorePickerDimProps {
  isOpen: boolean
  toggleDimIsOpen: () => void
}

export const StorePickerDim = ({isOpen, toggleDimIsOpen}: StorePickerDimProps) => {

  const {width} = useWindowDimensions()

  const onClickPlayStore = () => window.open(APP_STORE_WARD)
  const onClickAppStore = () => window.open(IOS_APP_STORE_WARD)

  return (
    isOpen ? (
      <DimBG>
        <DimWrap>
          <Button className='delete' bgImgSrc={deleteBtn} onClick={toggleDimIsOpen}></Button>
          <BtnWrap>
              <Button className='store' bgImgSrc={width > 600 ? googleBtn : mo_googleBtn} onClick={onClickPlayStore}></Button>
              <Button className='store' bgImgSrc={width > 600 ? appStoreBtn : mo_appStoreBtn} onClick={onClickAppStore}></Button>
          </BtnWrap>
        </DimWrap>
      </DimBG>
    ) : <></>
  )
}
